import React, { useState } from 'react';
import styled from 'styled-components';
import useActiveSection from '../hooks/useActiveSection';
import { smoothScrollTo } from '../utils/scroll';
import { ACCENT_COLOR } from '../styles/style';
import ImgMe from '../images/me.jpg'

const navItems = [
  { id: 'home', label: 'Home' },
  { id: 'about', label: 'O mnie' },
  { id: 'services', label: 'Oferta' },
  { id: 'portfolio', label: 'Portfolio' },
  { id: 'contact', label: 'Kontakt' },
];

const SidebarContainer = styled.aside`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 15%;
  background-color: #1a1a1a;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2rem 1rem;
  z-index: 100;
  align-items: center;
  .top-menu{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .menu{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  @media (max-width: 1023px) {
    display: none;
  }
  .image{
    width: 140px; height: 140px;
    overflow: hidden;
    border-radius: 50%;
    border: 5px solid #343a40;
    box-shadow: 0px 10px 10pxrgba(0, 0, 0, 0.58);
    @media(min-width:1200px){
      width: 200px; height: 200px;
      border: 10px solid #343a40;
    }
    img{
      width:100%;
      max-width: 200px;
    }
  }
  .name{
      font-size: .8rem !important;
      margin-top:10px;
      font-weight: 600;
      @media(min-width:1200px){
        font-size: 1.2rem !important;
      }
  }
  .social {
  display: flex;
  gap: 30px;
}

.social a {
  font-size: 1.2rem;
  color: #ffffff99;
  transition: color 0.3s;
}

.social a:hover {
  color:${ACCENT_COLOR};
}
`;

const NavItem = styled.button.attrs(props => ({
  $active: props.$active,
}))`
  background: none;
  border: none;
  margin: .6rem 0;
  font-size: 1rem;
  text-align: left;
  color: ${({ $active }) => ($active ? ACCENT_COLOR : '#ffffff')};
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: Poppins;
  font-weight: 500;
transform: translateX(0);

&:hover {
  color:${ACCENT_COLOR};
}
`;

const Sidebar = () => {
const sectionIds = ['home', 'about', 'services', 'portfolio', 'contact'];
const active = useActiveSection(sectionIds);

  const handleClick = (id) => {
  const section = document.getElementById(id);
  if (section) {
    smoothScrollTo(id);
  }
};

const socialLinks = [
  {
    name: 'Facebook',
    iconClass: 'fab fa-square-facebook',
    url: 'https://www.facebook.com/wojtek.talanda',
    className: 'fb',
  },
  {
    name: 'WhatsApp',
    iconClass: 'fab fa-whatsapp',
    url: 'https://wa.me/48504705724',
    className: 'whatsapp',
  },
  {
    name: 'Email',
    iconClass: 'fas fa-envelope',
    url: 'mailto:talanda.wojciech@gmail.com',
    className: 'e-mail',
  },
];


  return (
    <SidebarContainer>
    <div className='top-menu'>
      <div className='image'>
          <img src={ImgMe} />
      </div>
      <p className='name'>Wojciech Tałanda</p>
    </div>
    <div className='menu'>
      {navItems.map(({ id, label }) => (
        <NavItem
          key={id}
          onClick={() => handleClick(id)}
          $active={active === id}
        >
          {label}
        </NavItem>
      ))}
      </div>
      <div className="social">
      {socialLinks.map(({ name, iconClass, url, className }) => (
        <a
          key={name}
          href={url}
          className={className}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={name}
        >
          <i className={iconClass}></i>
        </a>
      ))}
    </div>
    </SidebarContainer>
  );
};

export default Sidebar;
